import Types from "./Types";

export const getAllPdfsRequest = (body) => ({
  type: Types.GET_SUPERADMIN_PDFS_REQUEST,
  payload: body,
});

export const getAllPdfsSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_PDFS_SUCCESS,
  payload: data,
});

export const getAllPdfsFail = () => ({
  type: Types.GET_SUPERADMIN_PDFS_FAIL,
});

export const editPdfRequest = (formData) => ({
  type: Types.EDIT_SUPERADMIN_PDF_REQUEST,
  payload: formData,
});

export const editPdfSuccess = (data) => ({
  type: Types.EDIT_SUPERADMIN_PDF_SUCCESS,
  payload: data,
});

export const editPdfFail = () => ({
  type: Types.EDIT_SUPERADMIN_PDF_FAIL,
});

//LOADING
export const addPdfLoading = (isLoading) => ({
  type: Types.ADD_SUPERADMIN_PDFS_LOADING,
  payload: isLoading,
});

// Create Pdf
export const createPdfRequest = (formData, action) => ({
  type: Types.CREATE_SUPERADMIN_PDF_REQUEST,
  payload: formData,
  action: action,
});

export const createPdfSuccess = ({ data }) => ({
  type: Types.CREATE_SUPERADMIN_PDF_SUCCESS,
  payload: {
    data,
  },
});

export const createPdfFail = () => ({
  type: Types.CREATE_SUPERADMIN_PDF_FAIL,
});

export const deletePdfRequest = (id) => ({
  type: Types.DELETE_SUPERADMIN_PDF_REQUEST,
  payload: id,
});

export const deletePdfSuccess = (id) => ({
  type: Types.DELETE_SUPERADMIN_PDF_SUCCESS,
  payload: id,
});

export const deletePdfFail = () => ({
  type: Types.DELETE_SUPERADMIN_PDF_FAIL,
});

export const getCoursePdfRequest = (id) => ({
  type: Types.SUPERADMIN_GET_COURSE_PDF_REQUEST,
  payload: id,
});

export const getCoursePdfSuccess = (id) => ({
  type: Types.SUPERADMIN_GET_COURSE_PDF_SUCCESS,
  payload: id,
});

export const getCoursePdfFail = () => ({
  type: Types.SUPERADMIN_GET_COURSE_PDF_FAIL,
});
